import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import logo from "../../Assets/images/logo.png";
import { useSelector } from "react-redux";
const PersonalCharacterView = ({ loadMore }) => {
  const { userAvatar, totalCount, loading, loadingMore } = useSelector((state) => state.User);

  return (
    <>
      <div className="d-flex gap-2 flex-wrap">
        <Row className="w-100">
          {userAvatar?.length > 0 ? (
            userAvatar?.map((item, indx) => {
              return (
                <>
                  <Col md="4" sm="6" className="my-2">
                    <div className="cardCstm p-3 border rounded-4 bg-light shadow-sm h-100 position-relative">
                      <div className="top pt-2 pb-3 border-bottom border-secondary  ">
                        <div className="left">
                          <h5 className="m-0 fw-bold themeClr">
                            {item?.fullName}
                            <span
                              className="text-muted fw-sbold text-capitalize"
                              style={{ fontSize: 12 }}
                            >
                              ({item?.type})
                            </span>
                          </h5>
                          <div className="price mt-3">
                            <div className="imgWrp flex-shrink-0 w-100  ">
                              {item?.image ? (
                                <img
                                  src={item?.image}
                                  alt=""
                                  style={{ height: "200px" }}
                                  className=" w-100 h-100 object-fit-cover rounded"
                                />
                              ) : (
                                <img src={logo} alt="" className="img-fluid" />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="content">
                        {/* <div className="price mt-3 d-flex justify-content-between">
                          <h6 className="m-0 fw-bold"> Age: {item?.age}</h6>
                          <span
                            className="fw-sbold justify-content-end"
                            style={{ fontSize: 12 }}
                          >
                            {item?.gender}
                          </span>
                        </div> */}
                        <ul
                          className="list-unstyled ps-0 mb-0"
                          style={{ fontSize: 12 }}
                        >
                          <li>
                            <span className="d-flex justify-content-between px-2 mb-0">
                              <p className="fw-medium m-0">Gender</p>
                              <p className="m-0"> {item?.gender}</p>
                            </span>
                          </li>
                          <li className="d-flex">
                            <span className="px-2 m-0">
                              <p className="fw-medium m-0">Education</p>
                              <p className="m-0"> {item?.education}</p>
                            </span>
                          </li>
                          <li className="d-flex">
                            <span className="px-2 m-0">
                              <p className="fw-medium m-0">Profession</p>
                              <p className="m-0"> {item?.profession}</p>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                </>
              );
            })
          ) : (
            <div className="d-flex justify-content-center p-2">
              <p className="m-0">No Data Found</p>
            </div>
          )}
        </Row>
        {!loading && totalCount > userAvatar?.length && (
          <Button onClick={loadMore} className="mt-3">
            Load More
          </Button>
        )}
      </div>
    </>
  );
};

export default PersonalCharacterView;
